import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';

const PlayerStoryGroupCard = ({ title: groupTitle, stories, load, approveStory }) => {

    const [storyList, setStoryList] = useState([]);
    const [storyAuthor, setStoryAuthor] = useState('');

    //console.log('Draw card for ', groupTitle);

    useEffect(() => {
        if (stories === undefined) {
            setStoryList([]);
        } else {
            setStoryList(stories);
        }

    }, [stories]);

    useEffect(() => {
        if (groupTitle === undefined) {
            setStoryAuthor("Unknown");
        } else {
            setStoryAuthor(groupTitle);
        }

    }, [groupTitle]);


    const getTitle = (author, storyCount) => {
        if (storyCount == 1) {
            return `${groupTitle} (${storyCount})`;
        } else {
            return `${groupTitle} (${storyCount})`;
        }
    }

    return (
        <Card className={"m-1 story-card-eom"} >
            <Card.Header className={"going-on-header"}>
                <Card.Title> {getTitle(storyAuthor, storyList.length)}</Card.Title>
            </Card.Header>
            <Card.Body className={"story-card-body"}>
                <div className={"story-box"}>
                    {storyList.map((story, index) =>
                        <Row key={index} name={story.story_id} className={"py-1"}>
                            <Col xs={10}  onClick={() => load(story.story_id)}>
                                {story.story_owner} - {story.story_title}
                            </Col>

                            <Col xs={1}>
                            {story.story_status==='SUBMITTED'?
                                                <span onClick={() => approveStory(story.story_id)} className={"mx-1 px-2 badge text-bg-success"}>
                                                    pending
                                                </span>
                                               :null}
                                               </Col>

                        </Row>
                    )}

                </div>
            </Card.Body>
        </Card>



    );
}

export default PlayerStoryGroupCard;